import axios from "axios";
import { createMockApi } from "./mockApi";

export const IS_DEMO = process.env.REACT_APP_DEMO_MODE === "true";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = IS_DEMO ? "/api" : `${BACKEND_URL}/api`;

export const api = IS_DEMO
  ? createMockApi()
  : axios.create({ baseURL: API_BASE });

if (!IS_DEMO) {
  api.interceptors.request.use((config) => {
    const token = localStorage.getItem("atelier_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
}

export function formatINR(amount) {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);
}
